import React, { useState, useEffect, useCallback, useRef } from "react";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import OrderSummary from "../checkout-order-summary";
import CardInfo from "../../sections/card-info-checkout";
import ProgressBar from "../../sections/checkout-progress-bar";
import ShippingInfoSummary from "../../sections/shipping-info-summary";
import { MemoryRouter } from "react-router-dom";
import url from "url";
import querystring from "querystring";
import { getGearsOrderSummary, getGearsProgressBars } from "../../services/gearsCheckoutService";
import { clubSelector, selectUserState, staffInfoSelector } from "../../selectors/application";
import { billingInfoSelector, contactInfoSelector, deliverySelector, diffAddrSelector, orderNoSelector, pickupStoreSelector, shippingInfoSelector } from "../../selectors/gears-checkout";
import { connect, useSelector } from "react-redux";
import api from "../../utils/api";
import { canUseDOM } from "../../utils";
import CheckoutErrorView from "../../sections/checkout-error-view/index";
import { _3dsStatus, orderTypes, PickupInStoreCode } from "../../utils/lynkco-constants";
import CheckoutPaymentFrame from "../../sections/checkout-payment-frame";
import getSiteInfo from "../../utils/getSiteInfo";
import { multiBindConsents } from "../../services/consentService";
import useQuery from "../../utils/useQuery";
import { getDeliveryMethodInfo } from "../../services/orderService";
import { getCart } from "../../services/cartService";
import { appendQuery } from "../../utils/urlHelper";
import { getApiError } from "../../services/siteService";
import { buildAddress, buildBillingAddr, saveCheckoutAddress } from "../../services/checkoutService";
import { S_GEAR_SAVE_PAYMENT, webStorage } from "../../utils/webStorage";
import { useErrorView } from "../../hooks/useErrorView";

const CheckoutPaymentOnline = ({ page, rendering, fields, lang }) => {
  /*Redux start*/
  const user = useSelector(selectUserState);
  const delivery = useSelector(deliverySelector);
  const billingFormData = useSelector(billingInfoSelector);
  const shippingFormData = useSelector(shippingInfoSelector);
  const contactFormData = useSelector(contactInfoSelector);
  const diffAddr = useSelector(diffAddrSelector);
  const orderNo = useSelector(orderNoSelector);
  const staffInfo = useSelector(staffInfoSelector);
  const pickupStore = useSelector(pickupStoreSelector);
  const club = useSelector(clubSelector);
  /*Redux end*/
  console.log("delivery", delivery);
  const { progressBar, selectedBar, summaryItem, shippingAddressHeading, contactInfoHeading, deliveryMethodHeading, cardInfo } = fields;
  const [shippingInfo, setShippingInfo] = useState(null);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [cartQtyList, setCartQtyList] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const orderData = useRef();
  // const [orderData, setOrderData] = useState(null);
  const [productsGA, setProductsGA] = useState(null);

  const [amount, setAmount] = useState(null);
  const [orderSummary, setOrderSummary] = useState({});
  const [barProps, setBarProps] = useState({ steps: [] });
  const query = useQuery();
  const { handleError, errorViewProps } = useErrorView();
  const isPickupInStore = useCallback(() => {
    return delivery.code === PickupInStoreCode;
  }, [delivery]);
  let shippingRows = shippingFormData ? [`${shippingFormData.firstName || ""} ${shippingFormData.lastName || ""}`, `${shippingFormData.street || ""} ${shippingFormData.apartment || ""}`, `${shippingFormData.postalCode || ""} ${shippingFormData.city || ""}`] : [];
  let contactRows = contactFormData ? [contactFormData.email || "", `${contactFormData.phoneArea || ""}${contactFormData.phone || ""}`] : null;
  const { gearsDeliveryLink, gearsDoneLink } = page.fields;
  useEffect(() => {
    fillShippingRows(delivery).then();
  }, [delivery]);
  useEffect(() => {
    init().then();
  }, []);
  const init = async () => {
    getGearsProgressBars(progressBar, selectedBar).then(value => {
      if (value) setBarProps(value);
    });
    const resCart = await getCart(lang);
    const { skuList, afterDiscountTotalPrice } = resCart.obj;
    const cartQtyList = skuList.map(x => ({
      skuId: x.skuId,
      qty: x.skuCount
    }));
    setTotalAmount(afterDiscountTotalPrice);
    setCartQtyList(cartQtyList);
    const { obj: promotions } = await api.user.promotion(null, {
      skuIds: cartQtyList.map(e => e.skuId)
    });
    const body = {
      deliveryId: delivery?.id,
      skuQtyVoList: cartQtyList,
      promotions
    };

    if (isPickupInStore()) {
      // console.log("pickupStore", pickupStore);
      body.storeCode = pickupStore.code;
      body.deliveryStoreCode = pickupStore.code;
    } else if (staffInfo) {
      body.storeCode = club.code;
    }
    getGearsOrderSummary(afterDiscountTotalPrice, body, summaryItem).then(([_orderData, summary]) => {
      // console.log("orderData", _orderData);
      setAmount(_orderData.grandTotal);
      setOrderSummary(summary);
      orderData.current = _orderData;
      // /** Measurements */
      if (canUseDOM) {
        let dataLayer = window.dataLayer || [];
        let products = [];
        _orderData.orderItems.forEach(item => {
          let product = {
            name: item.spuName.toLowerCase().replace(/ /g, "-"),
            // id: "product_sku",
            price: item.paymentAmt, // Product price
            quantity: item.qty // Product quantity
            // brand: "product_brand", // Product brand
            // category: "Level_1/Level_2/Level_3", // Product category (max. 5 levels)
            // variant: "product_variant"
          };
          products.push(product);
        });
        dataLayer.push({
          event: "checkout",
          step: 3,
          products: products
        });
        setProductsGA(products);
      }
    });
  };
  const fillShippingRows = async delivery => {
    const deliveryDict = await getDeliveryMethodInfo(delivery.code);
    // console.log("delivery", delivery);
    // console.log("deliveryDict", deliveryDict);
    setShippingInfo({
      shippingAddress: {
        heading: shippingAddressHeading.value,
        rows: shippingRows,
        link: { url: gearsDeliveryLink.value.href }
      },
      contactInfo: {
        heading: contactInfoHeading.value,
        rows: contactRows,
        link: { url: gearsDeliveryLink.value.href }
      },
      deliveryMethod: {
        heading: deliveryMethodHeading.value,
        rows: [deliveryDict?.dicName],
        value: delivery?.cost,
        link: { url: gearsDeliveryLink.value.href }
      }
    });
  };
  const onPayment = (url, payMethodName) => {
    if (payMethodName === "IDeal") {
      global.location.href = url;
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      setIframeUrl(url);
    }
  };
  const onSubmit = async ({ isValid, paymentRegistrationToken, bankCardId, paymentToken }) => {
    const savePayment = webStorage.get(S_GEAR_SAVE_PAYMENT);
    if (isValid) {
      try {
        let orderNo = query?.orderNo;
        let orderId = query?.orderId;
        if (!orderNo) {
          const siteInfo = await getSiteInfo();
          const consentNos = cardInfo.fields.termsAndConditions.map(x => x.id);
          await multiBindConsents(contactFormData.email, siteInfo.country, consentNos);
          const phoneAreaCode = contactFormData.phoneArea ? contactFormData.phoneArea : "";
          const phone = contactFormData.phone;
          const mobile = `${phoneAreaCode}${phone}`;
          const resCart = await getCart(lang);
          const { skuList } = resCart.obj;
          const cartQtyList = skuList.map(x => ({
            skuId: x.skuId,
            qty: x.skuCount
          }));
          const saveBody = {
            promotions: orderData.current.promotions,
            deliveryId: delivery.id,
            skuQtyVoList: cartQtyList,
            subType: orderTypes.gear,
            contactEmail: contactFormData.email,
            contactMobile: mobile
          };
          if (isPickupInStore()) {
            saveBody.billingAddress = buildBillingAddr(billingFormData, contactFormData, true);
          } else if (diffAddr) {
            saveBody.billingAddress = buildBillingAddr(billingFormData, contactFormData, true);
            saveBody.receiverInfoAddress = buildAddress("receiver", shippingFormData, contactFormData, true);
          } else {
            saveBody.billingAddress = buildBillingAddr(shippingFormData, contactFormData, false);
            saveBody.receiverInfoAddress = buildAddress("receiver", shippingFormData, contactFormData, false);
          }
          if (isPickupInStore()) {
            saveBody.storeCode = pickupStore.code;
            saveBody.deliveryStoreCode = pickupStore.code;
          } else if (club) {
            saveBody.storeCode = club.code;
            saveBody.staff = staffInfo?.email;
          }
          const { obj } = await api.order.save(null, saveBody);
          orderNo = obj.orderNo;
          orderId = obj.orderId;
        }

        const doneLink = url.parse(gearsDoneLink.value.href);
        const doneLinkQuery = querystring.parse(doneLink.query);
        const redirect = decodeURIComponent(doneLinkQuery.redirect);
        const returnUrl = decodeURIComponent(
          appendQuery(gearsDoneLink.value.href, {
            ...doneLinkQuery,
            redirect: encodeURIComponent(
              appendQuery(redirect, {
                orderNo: orderNo,
                orderId: orderId
              })
            )
          })
        );
        const payBody = {
          orderNo: orderNo, //订单号
          returnUrl: returnUrl
        };
        if (paymentRegistrationToken) {
          Object.assign(payBody, {
            paymentRegistrationToken,
            bankCardId,
            isRemember: 0
          });
        } else {
          Object.assign(payBody, {
            paymentToken,
            isRemember: savePayment ? 1 : 0
          });
        }
        const {
          obj: { status, redirectUrl, payMethodName }
        } = await api.order.pay(null, payBody);
        if (savePayment) {
          await saveCheckoutAddress(diffAddr, shippingFormData, billingFormData);
        }
        // /** Measurements */
        // let dataLayer = window.dataLayer || [];
        // let event = {
        //   event: "purchase",
        //   transaction: {
        //     id: orderId || orderNo,
        //     // affiliation: iframeUrl, // Website on which order was made
        //     revenue: amount,
        //     tax: orderData?.tax,
        //     shipping: orderData?.shipping,
        //     coupon: orderData?.promotions
        //   },
        //   products: productsGA
        // };
        switch (status) {
          case _3dsStatus.pendingHasLink:
            onPayment && onPayment(redirectUrl, payMethodName);
            // dataLayer.push(event);
            break;
          case _3dsStatus.successNoLink:
            onPayment && onPayment(returnUrl, payMethodName);
            // dataLayer.push(event);
            break;
          case _3dsStatus.failed:
            await handleError(_3dsStatus.failed);
            break;
          default:
            break;
        }
      } catch (ex) {
        await handleError(ex?.code);
      }
    }
  };
  if (iframeUrl) {
    return <CheckoutPaymentFrame {...{ iframeUrl }} />;
  } else {
    return (
      <section className="checkout-payment grid" datasourceid={rendering.dataSource}>
        <MemoryRouter>
          <ProgressBar {...barProps} />
        </MemoryRouter>
        {shippingInfo && <ShippingInfoSummary {...{ ...shippingInfo }} />}
        <CardInfo
          {...{
            ...cardInfo?.fields,
            user,
            lang,
            amount: amount,
            onSubmit: payload => onSubmit(payload)
          }}
        />
        <div className="summary-section">
          <OrderSummary {...orderSummary} />
        </div>
        {errorViewProps.error && <CheckoutErrorView {...errorViewProps} />}
      </section>
    );
  }
};
export default withSitecoreContext()(CheckoutPaymentOnline);
